import {queryOptions, useQueryClient} from '@tanstack/react-query';
import {api} from './client';
import {meQueryOptions} from './auth';
import {
  mainResumableEndpoint,
  type ResumableUploadResult,
} from './uploadResumable';
import {useResumableUploadQueue, type ResumableQueueApi} from './useResumableUploadQueue';

export interface FileItem {
  id: string;
  driveFileId: string;
  filename: string;
  sizeBytes: number;
  mimeType: string | null;
  // Момент створення resumable-сесії на сервері. null для старих записів,
  // створених до введення поля — тоді тривалість не показуємо.
  uploadStartedAt: string | null;
  uploadedAt: string;
}

export interface FilesResponse {
  items: FileItem[];
}

export type UploadResponse = ResumableUploadResult;

export const filesQueryOptions = queryOptions({
  queryKey: ['files'],
  queryFn: () => api<FilesResponse>('/files?limit=50'),
});

// Re-export UploadItem etc. з загального хука — щоб старі імпорти з '../api/files'
// не ламалися. UploadItem-shape ідентичний у всіх 4 підсистемах.
export type {UploadItem, UploadStatus} from './useResumableUploadQueue';
export type {UploadProgress, AttemptInfo} from './uploadResumable';

// Тонкий wrapper над спільним useResumableUploadQueue з прив'язкою до
// дашборд-ендпойнта (POST /api/upload/sessions?anketaId=N) і інвалідацією
// кешу списку файлів + meQueryOptions (для usedSpace etc.).
export function useUploadQueue(anketaId: number | null): ResumableQueueApi {
  const qc = useQueryClient();
  return useResumableUploadQueue({
    endpoint: anketaId === null ? null : mainResumableEndpoint(anketaId),
    onAfterDone: () => {
      qc.invalidateQueries({queryKey: filesQueryOptions.queryKey});
      qc.invalidateQueries({queryKey: meQueryOptions.queryKey});
    },
  });
}
